"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _debounce = _interopRequireDefault(require("lodash/debounce"));
var EntryBlockHelper = /*#__PURE__*/function () {
  function EntryBlockHelper() {
    var _this = this;
    (0, _classCallCheck2["default"])(this, EntryBlockHelper);
    this.visible = false;
    Entry.addEventListener('workspaceChangeMode', function () {
      if (_this._blockView) {
        _this.renderBlock(_this._blockView.type);
      }
    });
    this.resize = (0, _debounce["default"])(this.resize, 300);
  }
  return (0, _createClass2["default"])(EntryBlockHelper, [{
    key: "generateView",
    value: function generateView(parentView) {
      if (this.parentView_) {
        return;
      }
      /** @type {!Element} parent view */
      this.parentView_ = parentView;
      var helper = this;
      helper.blockHelpData = EntryStatic.blockInfo;
      var blockHelperWrapper = Entry.createElement('div', 'entryBlockHelperWorkspaceWrapper');
      var blockHelperView = Entry.createElement('div', 'entryBlockHelperWorkspace');
      blockHelperWrapper.appendChild(blockHelperView);
      this.view = blockHelperWrapper;
      if (Entry.isForLecture) {
        blockHelperView.addClass('lecture');
      }
      helper.parentView_.appendChild(blockHelperWrapper);
      var blockHelperContent = Entry.createElement('div', 'entryBlockHelperContentWorkspace');
      this._contentView = blockHelperContent;
      var commandTitle = Entry.createElement('div');
      commandTitle.addClass('entryBlockHelperTitle textModeElem');
      commandTitle.textContent = 'Command';
      blockHelperContent.appendChild(commandTitle);
      blockHelperContent.addClass('entryBlockHelperIntro');
      if (Entry.isForLecture) {
        blockHelperContent.addClass('lecture');
      }
      blockHelperView.appendChild(blockHelperContent);
      helper.blockHelperContent_ = blockHelperContent;
      helper.blockHelperView_ = blockHelperView;
      var blockHelperBlock = Entry.createElement('div', 'entryBlockHelperBlockWorkspace');
      helper.blockHelperContent_.appendChild(blockHelperBlock);
      var descTitle = Entry.createElement('div');
      descTitle.addClass('entryBlockHelperTitle textModeElem');
      descTitle.textContent = 'Explanation';
      blockHelperContent.appendChild(descTitle);
      var blockHelperDescription = Entry.createElement('div', 'entryBlockHelperDescriptionWorkspace');
      blockHelperDescription.addClass('entryBlockHelperContent selectAble');
      helper.blockHelperContent_.appendChild(blockHelperDescription);
      blockHelperDescription.textContent = Lang.Helper.Block_click_msg;
      this.blockHelperDescription_ = blockHelperDescription;
      var elementsTitle = Entry.createElement('div');
      elementsTitle.addClass('entryBlockHelperTitle textModeElem');
      elementsTitle.textContent = 'Element';
      blockHelperContent.appendChild(elementsTitle);
      this._elementsTitle = elementsTitle;
      this._elementsContainer = Entry.createElement('div', 'entryBlockHelperElementsContainer');
      this._elementsContainer.addClass('entryBlockHelperContent textModeElem selectAble');
      blockHelperContent.appendChild(this._elementsContainer);
      var blockHelperLink = Entry.createElement('div', 'entryBlockHelperLinkWorkspace');
      blockHelperLink.addClass('blockHelperLink');
      var helperLink = Entry.createElement('a', 'entryBlockHelperLink');
      helperLink.addClass('linkTextElem');
      helperLink.setAttribute('target', '_blank');
      blockHelperLink.appendChild(helperLink);
      blockHelperContent.appendChild(blockHelperLink);
      this.blockHelperLink_ = helperLink;
      if (typeof CodeMirror !== 'undefined') {
        var codeMirrorTitle = Entry.createElement('div');
        codeMirrorTitle.addClass('entryBlockHelperTitle textModeElem');
        codeMirrorTitle.textContent = 'Example Code';
        blockHelperContent.appendChild(codeMirrorTitle);
        var codeMirrorView = Entry.createElement('div', 'entryBlockHelperCodeMirrorContainer');
        codeMirrorView.addClass('textModeElem');
        blockHelperContent.appendChild(codeMirrorView);
        this.codeMirror = CodeMirror(codeMirrorView, {
          lineNumbers: true,
          value: '',
          mode: {
            name: 'python'
          },
          indentUnit: 4,
          theme: 'default',
          viewportMargin: 10,
          styleActiveLine: false,
          readOnly: true
        });
        this._doc = this.codeMirror.getDoc();
        this._codeMirror = this.codeMirror;
        var codeMirrorDescTitle = Entry.createElement('div');
        codeMirrorDescTitle.addClass('entryBlockHelperTitle textModeElem');
        codeMirrorDescTitle.textContent = 'Example Explanation';
        blockHelperContent.appendChild(codeMirrorDescTitle);
        this._codeMirrorDesc = Entry.createElement('div');
        this._codeMirrorDesc.addClass('entryBlockHelperContent textModeElem selectAble');
        blockHelperContent.appendChild(this._codeMirrorDesc);
      }
      this._renderView = new Entry.RenderView($(blockHelperBlock), 'LEFT_MOST');
      this.code = new Entry.Code([]);
      this.code.isFor = 'blockHelper';
      this._renderView.changeCode(this.code);
      this.first = true;
    }
  }, {
    key: "bindWorkspace",
    value: function bindWorkspace(workspace) {
      if (!workspace) {
        return;
      }
      if (this._blockViewObserver) {
        this._blockViewObserver.destroy();
      }
      this.workspace = workspace;
      if (this._renderView) {
        this._renderView.workspace = workspace;
      }
      this._blockViewObserver = workspace.observe(this, '_updateSelectedBlock', ['selectedBlockView']);
    }
  }, {
    key: "renderBlock",
    value: function renderBlock(type) {
      var description = Lang.Helper[type];
      if (!type || !this.visible || !description || Entry.block[type].isPrimitive) {
        return;
      }
      if (this.first) {
        this.blockHelperContent_.removeClass('entryBlockHelperIntro');
        this.first = false;
      }
      var code = this.code;
      code.clear();
      var def = Entry.block[type].def || {
        type: type
      };
      if (this.workspace.getMode() === Entry.Workspace.MODE_VIMBOARD) {
        this._contentView.addClass('textMode');
        this.blockHelperDescription_.textContent = Lang.PythonHelper["".concat(type, "_desc")];
        var elements = Lang.PythonHelper["".concat(type, "_elements")];
        this._elementsContainer.textContent = '';
        if (elements) {
          this._elementsTitle.removeClass('entryRemove');
          elements = elements.split('%next');
          while (elements.length) {
            (function (elems) {
              var contents = elems.split('-- ');
              var box = Entry.createElement('div');
              box.addClass('entryBlockHelperElementsContainer');
              var left = Entry.createElement('div');
              left.textContent = contents[0];
              left.addClass('elementLeft');
              var right = Entry.createElement('div');
              right.addClass('elementRight');
              right.textContent = contents[1];
              box.appendChild(left);
              box.appendChild(right);
              this._elementsContainer.appendChild(box);
            }).bind(this)(elements.shift());
          }
        } else {
          this._elementsTitle.addClass('entryRemove');
        }
        this._codeMirrorDesc.textContent = Lang.PythonHelper["".concat(type, "_exampleDesc")];
        var exampleCode = Lang.PythonHelper["".concat(type, "_exampleCode")];
        this._codeMirror.setValue(exampleCode);
        this.codeMirror.refresh();
        def = Entry.block[type].pyHelpDef || def;
      } else {
        this._contentView.removeClass('textMode');
        this.blockHelperDescription_.textContent = description;
        var category = Entry.block[type].wikiClass || Entry.Utils.getBlockCategory(type);
        if (category) {
          this.blockHelperLink_.textContent = Lang.Helper.link_to_entry_wiki;
          this.blockHelperLink_.href = Lang.Helper["wiki_link_".concat(category)];
        } else {
          this.blockHelperLink_.textContent = '';
          this.blockHelperLink_.href = '';
        }
      }
      code.createThread([def]);
      code.board.align();
      code.board.resize();
      this._renderView.align();
      this._renderView.setDomSize();
    }
  }, {
    key: "getView",
    value: function getView() {
      return this.view;
    }
  }, {
    key: "resize",
    value: function resize() {
      this.codeMirror && this.codeMirror.refresh();
    }
  }, {
    key: "_updateSelectedBlock",
    value: function _updateSelectedBlock() {
      var blockView = this.workspace.selectedBlockView;
      // noinspection EqualityComparisonWithCoercionJS
      if (!blockView || !this.visible || blockView == this._blockView) {
        return;
      }
      var type = blockView.block.type;
      this._blockView = blockView;
      this.renderBlock(type);
    }
  }]);
}();
var _default = exports["default"] = EntryBlockHelper;